
import { supabase } from '@/integrations/supabase/client';
import { createReferralNotification } from '@/services/notifications';

/**
 * Check if a referral was created recently (within last 10 minutes) 
 * for this user and professional - to prevent accidental duplicate clicks
 */
export const checkExistingReferral = async (
  userId: string,
  professionalId: string
): Promise<{ exists: boolean; phoneNumber?: string }> => {
  try {
    // Calculate timestamp for 10 minutes ago
    const tenMinutesAgo = new Date();
    tenMinutesAgo.setMinutes(tenMinutesAgo.getMinutes() - 10);
    
    const { data, error } = await supabase
      .from('referrals')
      .select('phone_number, date')
      .eq('user_id', userId)
      .eq('professional_id', professionalId)
      .gte('date', tenMinutesAgo.toISOString())
      .order('date', { ascending: false })
      .limit(1)
      .maybeSingle();

    if (error) {
      console.error("Error checking existing referral:", error);
      return { exists: false };
    }

    return { 
      exists: !!data, 
      phoneNumber: data?.phone_number 
    };
  } catch (error) {
    console.error("Error checking existing referral:", error);
    return { exists: false };
  }
};

/**
 * Save referral to the database (only if doesn't exist)
 */
export const saveReferral = async (
  userId: string,
  professionalId: string,
  professionalName: string,
  phoneNumber: string,
  profession: string,
  userName?: string // נחוץ להתראה (ניתן להעביר מהקריאה)
): Promise<boolean> => {
  try {
    // בדיקה אם כבר קיימת פנייה
    const { exists } = await checkExistingReferral(userId, professionalId);
    
    if (exists) {
      console.log("Referral already exists within last 10 minutes, skipping save");
      return true; // החזרת true כי פנייה קיימת לאחרונה
    }

    console.log("Saving new referral:", {
      userId, professionalId, professionalName, phoneNumber, profession
    });

    const { error } = await supabase
      .from('referrals')
      .insert({
        user_id: userId,
        professional_id: professionalId,
        professional_name: professionalName,
        phone_number: phoneNumber,
        profession: profession,
        date: new Date().toISOString(),
        status: 'new'
      });

    if (error) {
      console.error("Error saving referral:", error);
      return false;
    }

    // יצירת התראה לבעל המקצוע שקיבל הפנייה
    await createReferralNotification(professionalId, professionalName, phoneNumber, userName);

    return true;
  } catch (error) {
    console.error("Error saving referral:", error);
    return false;
  }
};
